<template>
  <div class="cc-radio-card-group">
    <p v-if="legend" class="cc-radio-card-group__legend">{{ legend }}</p>
    <div
      class="cc-radio-card-group__grid"
      role="radiogroup"
      :aria-label="legend || name"
    >
      <label
        v-for="(option, index) in options"
        :key="option.value"
        class="cc-radio-card"
        :class="{ 'cc-radio-card--selected': modelValue === option.value }"
        :style="{ '--cc-card-delay': `${index * 0.05}s` }"
      >
        <input
          type="radio"
          :name="name"
          :value="option.value"
          :checked="modelValue === option.value"
          class="cc-radio-card__input"
          @change="select(option.value)"
        />
        <span class="cc-radio-card__indicator" aria-hidden="true" />
        <span class="cc-radio-card__icon-wrap">
          <i :class="option.icon" aria-hidden="true" />
        </span>
        <span class="cc-radio-card__body">
          <span class="cc-radio-card__title">{{ option.title }}</span>
          <span class="cc-radio-card__description">{{ option.description }}</span>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateCompanyRadioCardGroup',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    legend: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    select(value) {
      this.$emit('update:modelValue', value);
    },
  },
};
</script>
